import React from 'react'
import injectSheet from 'react-jss'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { withStyles } from '@mui/styles'
import StyledLink from '../StyledLink'

const styles = {
	selectMenuDropdown: {
		padding: '0px 26px 2px 2px',
	},
}

export const steps = {
	default: {
		pageSize: 25,
		options: [10, 25, 50, 100, 250, 500, 1000],
	},
}

export const PagingControl = ({
	pageSize = steps.default.pageSize,
	options = steps.default.options,
	total = 0,
	totalRecordsLabel = 'records',
	onChange,
	isBottom,
	classes,
	exportLink,
}) =>
	total > 0 ? (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				height: '45px',
				marginTop: isBottom ? '-7px' : '20px',
				marginBottom: isBottom ? '0px' : '7px',
			}}
		>
			<Grid container direction="row" alignItems="baseline" justify="flex-end">
				<Grid item>
					<Typography className="text-muted" sx={{ margin: '18px 0px 0px', fontSize: '14px' }}>
						Viewing&nbsp;
						{pageSize > total
							? total + ' ' + totalRecordsLabel
							: pageSize + ' of ' + total + ' ' + totalRecordsLabel}
					</Typography>
				</Grid>
				{exportLink &&
					<StyledLink
						to={exportLink}
						contents={ "Export results" }
						newWindow={true}
						styles={{ marginLeft: '13px' }}
					/>
				}
				<Grid item style={{flexGrow:1}}></Grid>
				<Grid item>
					<Typography component='span' sx={{ marginRight: '10px', fontSize: '14px' }}>Rows per page:</Typography>
				</Grid>
				<Grid item>
					<Select
						value={pageSize}
						onChange={(e, i, v) => {
							onChange(e.target.value)
						}}
						disableUnderline
						sx={{ height: 'auto', verticalAlign: 'middle', marginTop:'5px', fontSize:'14px', border:'none', paddingBottom: '0' }}
						classes={{ selectMenu: classes.selectMenuDropdown }}
						variant={'standard'}
					>
						{options.map(s => (
							<MenuItem key={s} value={s}>
								{s}
							</MenuItem>
						))}
					</Select>
				</Grid>
			</Grid>
		</div>
	) : null

export default injectSheet(styles)(PagingControl)
